import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { Shield, FileText, Lock, Info, ArrowRight } from "lucide-react";
export default function LegalInformationAndDataProtectionOverview() {
  const legalSections = [{
    id: 1,
    title: "Datenschutzerklärung",
    description: "Erfahren Sie, wie wir Ihre persönlichen Daten erheben, verarbeiten und schützen.",
    icon: Shield,
    link: "https://muensterland-industrieservice.com/impressum-und-datenschutz/dsgvo/"
  }, {
    id: 2,
    title: "Impressum",
    description: "Rechtliche Informationen über unser Unternehmen und Kontaktdaten gemäß gesetzlicher Anforderungen.",
    icon: FileText,
    link: "https://muensterland-industrieservice.com/impressum-und-datenschutz/impressum/"
  }, {
    id: 3,
    title: "Cookie-Richtlinie",
    description: "Informationen über die Verwendung von Cookies und ähnlichen Technologien auf unserer Website.",
    icon: Lock,
    link: "https://muensterland-industrieservice.com/impressum-und-datenschutz/cookie_richtlinie/"
  }, {
    id: 4,
    title: "Allgemeine Geschäftsbedingungen",
    description: "Die rechtlichen Rahmenbedingungen für die Nutzung unserer Dienstleistungen und Website.",
    icon: Info,
    link: "https://muensterland-industrieservice.com/impressum-und-datenschutz/allgemeine_geschaeftsbedingungen/"
  }];
  return <section className="py-16 px-4 bg-background">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12 animate-fade-in-up">
          <h2 className="text-4xl font-display font-semibold text-foreground mb-4">
            <span className="underline">Rechtliche</span> Informationen
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Transparenz und Datenschutz sind uns wichtig. Hier finden Sie alle relevanten rechtlichen Informationen.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {legalSections.map((section, i) => {
          const Icon = section.icon;
          return <Card key={section.id} data-index={i} className="border-2 border-border hover:border-primary/50 transition-all duration-[var(--duration-medium)] hover-lift bg-muted-light shadow-soft hover:shadow-medium">
                <CardHeader>
                  <div className="flex items-start gap-4">
                    <div className="p-3 rounded-lg bg-primary/10 text-primary shrink-0">
                      <Icon className="size-6" />
                    </div>
                    <div className="flex-1">
                      <CardTitle className="text-xl mb-2 underline">{section.title}</CardTitle>
                      <CardDescription className="text-sm leading-relaxed">
                        {section.description}
                      </CardDescription>
                    </div>
                  </div>
                </CardHeader>
                <CardContent>
                  <Link to={section.link}>
                    <Button variant="default" className="w-full btn-primary group">
                      Mehr erfahren
                      <ArrowRight className="size-4 transition-transform group-hover:translate-x-1" />
                    </Button>
                  </Link>
                </CardContent>
              </Card>;
        })}
        </div>

        <div className="mt-12 text-center animate-fade-in-up-delay-200">
          <Card className="inline-block border-2 border-border bg-accent/5 shadow-soft">
            <CardContent className="py-6 px-8">
              <p className="text-sm text-muted-foreground">
                Bei Fragen zu unseren rechtlichen Informationen oder Datenschutzpraktiken kontaktieren Sie uns gerne.
              </p>
              <Link to="/KontaktPage" className="inline-block mt-4">
                <Button className="btn-primary">
                  Kontakt aufnehmen
                </Button>
              </Link>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>;
}